import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ModalBuilder, Form, notifySuccess } from "@redriver/cinnamon";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { getVolumeRewrite, requestVolumeRewrite } from "./";
import { UnitTable } from "./Components";
import { Grid, GridColumn, GridRow } from "semantic-ui-react";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { PermissionCheck } from "features/../../../shared/components/auth";

const VolumeRewriteModal = ({ as: As, scheduleId, disabled }) => {
  const { t } = useTranslation("agreements", { keyPrefix: "ScheduleRow" });
  const { t: tvr } = useTranslation("agreements", {
    keyPrefix: "ScheduleRow.VolumeRewrite",
  });

  const dispatch = useDispatch();
  return (
    <PermissionCheck action={Actions.SubmitRequest} target={Targets.Schedules}>
      <PermissionCheck action={Actions.View} target={Targets.Schedules}>
        <ModalBuilder
          renderTrigger={(showModal) => (
            <As onClick={showModal} disabled={disabled}>
              {t("Actions.Volume_Only_Rewrite")}
            </As>
          )}
          withForm
          loadAction={getVolumeRewrite}
          loadParams={scheduleId}
          submitAction={requestVolumeRewrite}
          submitParams={scheduleId}
          onSubmitted={() => {
            dispatch(notifySuccess(t("Actions.Submitted_Successfully")));
          }}
          renderModal={(modalProps, formProps) => {
            return (
              <TranslatedModal.Edit
                className="large-modal volume-rewrite-modal upgrade-request-modal"
                header={tvr("Header")}
                submitLabel={tvr("Submit_Request")}
                submitDisabled={
                  !formProps.value.applicableFromPrevious &&
                  !formProps.value.applicableFromNext &&
                  !formProps.value.backToStart
                }
                {...modalProps}
              >
                <Form {...formProps}>
                  {() => (
                    <React.Fragment>
                      <Grid className="upgrade-types">
                        <GridRow>
                          <GridColumn width={1} className="right-align">
                            <Form.Checkbox
                              field="backToStart"
                              checked={formProps.value.backToStart}
                              fluid
                            />
                          </GridColumn>
                          <GridColumn width={15}>
                            <label>{tvr("Back_To_Start")}</label>
                          </GridColumn>
                        </GridRow>
                        <GridRow>
                          <GridColumn width={1} className="right-align">
                            <Form.Checkbox
                              field="applicableFromPrevious"
                              checked={formProps.value.applicableFromPrevious}
                              fluid
                            />
                          </GridColumn>
                          <GridColumn width={15}>
                            <label>{tvr("applicable_from_previous")}</label>
                          </GridColumn>
                        </GridRow>
                        <GridRow>
                          <GridColumn width={1} className="right-align">
                            <Form.Checkbox
                              field="applicableFromNext"
                              checked={formProps.value.applicableFromNext}
                              fluid
                            />
                          </GridColumn>
                          <GridColumn width={15}>
                            <label>{tvr("applicable_from_next")}</label>
                          </GridColumn>
                        </GridRow>
                      </Grid>

                      <div className="unit-table-container">
                        <div className="vertical-scrollbar large">
                          <UnitTable formProps={formProps} />
                        </div>
                      </div>

                      <Form.TextArea
                        field="comments"
                        label={t("Additional_Comments")}
                        fluid
                        placeholder={t("Additional_Comments_Placeholder")}
                      />
                    </React.Fragment>
                  )}
                </Form>
              </TranslatedModal.Edit>
            );
          }}
        />
      </PermissionCheck>
    </PermissionCheck>
  );
};

export default VolumeRewriteModal;
